


















import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import ChargeInactivatedInstancesCard from './cards/charge-inactivated-instances-card.component.vue';
import NotifyCancellationCard from './cards/notify-cancellation-card.component.vue';

@Component({
  components: { ChargeInactivatedInstancesCard, NotifyCancellationCard },
})
export default class BusinessUnitSettingsConfiguration extends Vue {
  @Prop({ required: true, default: '' }) private businessUnitId!: string;

  created() {
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && this.$route.name.includes('Configuration')) {
        this.businessUnitId = businessUnit.id;
      }
    });
  }
}
